/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import {
  DepartmentsTooltip,
  ChipRoot,
  ChipDot,
  ChipLabel,
  CountBadge,
  TooltipHeader,
  TooltipTitle,
  TotalBadge,
  DepartmentList,
  DepartmentRow,
  DepartmentName,
  EmptyLabel,
} from "./styles";

// First associated department on the chip with a count of the rest; hovering lists them all.
export const DepartmentsChip = ({ departments, testId = "departments-chip" }) => {
  if (!Array.isArray(departments) || departments.length === 0) {
    return <EmptyLabel data-testid={`${testId}-empty`}>-</EmptyLabel>;
  }

  const [firstDepartment] = departments;
  const remainingCount = departments.length - 1;

  return (
    <DepartmentsTooltip
      placement="bottom-start"
      title={
        <div data-testid={`${testId}-tooltip`}>
          <TooltipHeader>
            <TooltipTitle>Associated departments</TooltipTitle>
            <TotalBadge>{departments.length}</TotalBadge>
          </TooltipHeader>
          <DepartmentList>
            {departments.map((department) => (
              <DepartmentRow key={department.id} data-testid={`${testId}-department-${department.id}`}>
                <DepartmentName>{department.name}</DepartmentName>
              </DepartmentRow>
            ))}
          </DepartmentList>
        </div>
      }
    >
      <ChipRoot data-testid={testId} tabIndex={0}>
        <ChipDot />
        <ChipLabel component="span">{firstDepartment.name}</ChipLabel>
        {remainingCount > 0 && (
          <CountBadge data-testid={`${testId}-count`}>+{remainingCount}</CountBadge>
        )}
      </ChipRoot>
    </DepartmentsTooltip>
  );
};
